import controller from './thing-registered.controller';

const template = require('./thing-registered.html');

export default {
    bindings: {
        reset: '<',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-registered/thing-registered.component.js